import React from 'react';
import { generateToggle, generateInputs } from './Form.service';
import { useTranslation } from 'react-i18next';


const RequestPeriodOverrideDropdown = ({ 
    toggleLabel, 
    toggleValue, 
    onToggleChange, 
    dropdownLabel, 
    dropdownValue,
    onDropdownChange 
  }) => {
      const { t } =  useTranslation('employmentBillboard', { keyPrefix: 'requestPeriodMonthsOverride' });

      const calendarMonthOptions = [...Array(7).keys()].map((x) => ({
          label: `${t('calendarMonthPrefix')}${x ? ` +${x}` : ''}`,
          value: x
      }));

      
  
      const mappedValue = calendarMonthOptions.find(x => x.value === dropdownValue);
  
      return (
        <div>
          {generateToggle(
              onToggleChange,
              toggleValue,
              toggleLabel,
              toggleLabel,
              ""
          )}
  
          {toggleValue && generateInputs(
              onDropdownChange,
              dropdownLabel,
              t('selectOption'),
              mappedValue,
              calendarMonthOptions,
              null,
              false,
          )}
        </div>
      );
  };

export default RequestPeriodOverrideDropdown;